module.exports = __webpack_public_path__ + "img/11f.4fffd818.png";